import { render, staticRenderFns } from "./artist.vue?vue&type=template&id=9fac94c0&scoped=true"
import script from "./artist.vue?vue&type=script&lang=js"
export * from "./artist.vue?vue&type=script&lang=js"
import style0 from "./artist.vue?vue&type=style&index=0&id=9fac94c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fac94c0",
  null
  
)

export default component.exports